import script from "./Alert.vue?vue&type=script&lang=ts&setup=true"
export * from "./Alert.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__